/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { nodeFileMgmtColumn } from "../../../Shared/Table/Columns";
import CustomDataGrid from "../../../Shared/Table/CustomDataGrid";
import { useSelector } from "react-redux";
import { GridCallbackDetails, GridRowParams, GridRowSelectionModel, GridToolbarContainer, MuiEvent } from "@mui/x-data-grid-pro";
import { Plus, Trash2 } from "lucide-react";
import { setOpenCustomDailog } from "../../../../store/helpers/helperReducers";
import { customDialogSelector } from "../../../../store/helpers/helperSelectors";
import AddNodeFileMgmt from "./AddNodeFileMgmt";
import { INodeFileMgmt } from "../../../../store/api/tasks/types";
import { useNodeFileMgmtData } from "./hooks";
import { Button } from "../../../ui/button";

export const NodeFileManagement = () => {
    const {
        dispatch,
        errorMsg,
        setErrorMsg,
        scheduledtasks,
        nodeFileMgmtFormData,
        setNodeFileMgmtFormData,
        addToFileMgmtListHandler,
        addNewNodeFileMgmt,
        deleteNodeFileMgmtRecord,
        selectedRowIds,
        setSelectedRowIds,
        modelOpenMode,
        setModelOpenMode,
    } = useNodeFileMgmtData();
    const { nodeFileMgmt = [] } = scheduledtasks;
    const openCustomDialog = useSelector(customDialogSelector);

    const rowDoubleClickHandler = (params: GridRowParams, event: MuiEvent, details: GridCallbackDetails) => {
        setModelOpenMode("Edit");
        setNodeFileMgmtFormData(params.row);
        dispatch(setOpenCustomDailog(true));
        dispatch(setErrorMsg({}));
    }
    const handleOnRowSelected = (rowIds: GridRowSelectionModel) => {
        setSelectedRowIds(rowIds);
    };

    const DataGridTitle = () => {
        return (
            <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
                <p className="text-sm font-medium">Create node file management records</p>
                <div className="flex items-center gap-1">
                    <Button variant="ghost" size="icon" title="Add" onClick={addNewNodeFileMgmt}>
                        <Plus className="h-5 w-5 text-primary" />
                    </Button>
                    {selectedRowIds.length > 0 && (
                        <Button variant="ghost" size="icon" title="Delete" onClick={deleteNodeFileMgmtRecord}>
                            <Trash2 className="h-5 w-5 text-destructive" />
                        </Button>
                    )}
                </div>
            </GridToolbarContainer>
        )
    }

    return (
        <>
            {openCustomDialog &&
                <AddNodeFileMgmt
                    nodeFileMgmtFormData={nodeFileMgmtFormData}
                    setNodeFileMgmtFormData={setNodeFileMgmtFormData}
                    addToFileMgmtListHandler={addToFileMgmtListHandler}
                    errorMsg={errorMsg}
                    modelOpenMode={modelOpenMode}
                />
            }
            <div className="flex items-center justify-center">
                <div className="w-full -mt-10">
                    <CustomDataGrid
                        rows={nodeFileMgmt}
                        columns={nodeFileMgmtColumn}
                        checkboxSelection={false}
                        tableId="nodeFileManagement"
                        disableColumnMenu={true}
                        disableRowSelectionOnClick={false}
                        getRowId={(row: INodeFileMgmt) => row.id}
                        slots={{ toolbar: DataGridTitle }}
                        hideFooter={true}
                        onRowDoubleClick={rowDoubleClickHandler}
                        onRowSelectionModelChange={handleOnRowSelected}
                    />
                </div>
            </div>
        </>
    );
};